"use strict";
module.exports = require('../../module.compiled').vendored['contexts'].HooksClientContext;

//# sourceMappingURL=hooks-client-context.js.map